import { createFileRoute } from "@tanstack/react-router";
import { PortalHomePage } from "@/features/portal-home/PortalHomePage";

export const Route = createFileRoute("/portal/")({ component: PortalHomePage });
